<template>
  <div class="szw-flex szw-w-full szw-h-full szw-justify-center szw-items-center szw-relative" :style="{ maxWidth: `${props.size}px`, height: `${props.size}px` }">
    <svg class="szw-absolute" :width="size" :height="size" :viewBox="`0 0 ${props.size} ${props.size}`" xmlns="http://www.w3.org/2000/svg">
      <!-- Left Circle (Based on Percentage 1) -->
      <path :d="describeArc(size / 2, size / 2, radius, angle1 + spacingAngle, 360)" fill="none" :stroke="color1" :stroke-width="strokeWidth"></path>
    </svg>
    <svg class="szw-absolute" :width="size" :height="size" :viewBox="`0 0 ${props.size} ${props.size}`" xmlns="http://www.w3.org/2000/svg">
      <!-- Right Circle (Based on Percentage 2) -->
      <path :d="describeArc(size / 2, size / 2, radius, spacingAngle, angle1)" fill="none" :stroke="color2" :stroke-width="strokeWidth"></path>
    </svg>
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  chartData: {
    type: Object,
    default: () => ({ left: 50, right: 50 }),
    required: true
  },
  size: {
    type: Number,
    default: 100
  },
  strokeWidth: {
    type: Number,
    default: 10
  },
  color1: {
    type: String,
    default: '#007bff'
  },
  color2: {
    type: String,
    default: '#ff0000'
  },
  spacing: {
    type: Number,
    default: 4
  },
  radius: {
    type: Number,
    default: 40
  }
})

const angle1 = computed(() => {
  if (+props.chartData.right + +props.chartData.left !== 100) {
    return (50 / 100) * 360 || 0
  } else {
    return (props.chartData.right / 100) * 360 || 0
  }
})

const spacingAngle = computed(() => {
  const angle = Math.asin(props.spacing / (2 * props.radius)) * (180 / Math.PI)
  return angle
})

const describeArc = (x, y, radius, startAngle, endAngle) => {
  const start = polarToCartesian(x, y, radius, endAngle)
  const end = polarToCartesian(x, y, radius, startAngle)
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1'
  const d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ')
  return d
}

const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  }
}
</script>
